import { gettext } from '@eventbrite/i18n';
import { css } from 'emotion';
import React, { Fragment } from 'react';
import IconButton from '../../iconButton/IconButton';
import TrashSvg from '../../iconography/icons/Trash';
import { useTheme } from '../../theme-context';
import { ITicket } from '../types';
import './checkout-panel.scss';

interface ITicketCheckoutLine {
    ticket: ITicket;
    removeTicketAction: (_: any) => void;
}

const TicketCheckoutLine = ({
    ticket,
    removeTicketAction,
}: ITicketCheckoutLine) => {
    const { id, variantId, section, row, seat, tier, variantName } = ticket;
    const { getFont } = useTheme();

    return (
        <Fragment>
            <div
                key="section"
                data-testid="section"
                className={css({
                    alignSelf: 'center',
                    fontFamily: getFont('desktop/body/medium').fontFamily,
                    fontWeight: getFont('desktop/body/medium').fontWeight,
                    fontSize: getFont('desktop/body/medium').fontSize,
                    lineHeight: `${
                        getFont('desktop/body/medium').lineHeightPx
                    }px`,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                })}
            >
                {section}
            </div>
            <div
                key="type"
                data-testid="variantName"
                className={css({
                    alignSelf: 'center',
                    fontFamily: getFont('desktop/body/medium').fontFamily,
                    fontWeight: getFont('desktop/body/medium').fontWeight,
                    fontSize: getFont('desktop/body/medium').fontSize,
                    lineHeight: `${
                        getFont('desktop/body/medium').lineHeightPx
                    }px`,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                })}
            >
                {variantName}
            </div>
            <div
                key="row"
                data-testid="row"
                className={css({
                    justifySelf: 'center',
                    alignSelf: 'center',
                    fontFamily: getFont('desktop/body/medium').fontFamily,
                    fontWeight: getFont('desktop/body/medium').fontWeight,
                    fontSize: getFont('desktop/body/medium').fontSize,
                    lineHeight: `${
                        getFont('desktop/body/medium').lineHeightPx
                    }px`,
                })}
            >
                {row}
            </div>
            <div
                key="seat"
                data-testid="seat"
                className={css({
                    justifySelf: 'center',
                    alignSelf: 'center',
                    fontFamily: getFont('desktop/body/medium').fontFamily,
                    fontWeight: getFont('desktop/body/medium').fontWeight,
                    fontSize: getFont('desktop/body/medium').fontSize,
                    lineHeight: `${
                        getFont('desktop/body/medium').lineHeightPx
                    }px`,
                })}
            >
                {seat}
            </div>
            <div
                key="tier"
                data-testid="tier"
                className={css({
                    background: tier,
                    alignSelf: 'center',
                    borderRadius: '50%',
                    width: '14px',
                    height: '14px',
                })}
            />
            <div
                key="remove-ticket"
                data-testid="remove-ticket"
                className={css({
                    alignSelf: 'center',
                    justifySelf: 'end',
                    height: '100%',
                })}
            >
                <div className="trash">
                    <IconButton
                        data-testid="remove-ticket-button"
                        iconType={<TrashSvg />}
                        title={gettext('Remove ticket')}
                        onClick={() => removeTicketAction({ id, variantId })}
                        style="none"
                    />
                </div>
            </div>
        </Fragment>
    );
};

export default TicketCheckoutLine;
